"use client";

import { SanityFAQ } from "@/sanity/lib/types";
import { useEffect, useState } from "react";
import Question from "../about/Question";
import { getFAQsByCategory } from "@/data/sanity-faqs";
import { Category } from "@/sanity/lib/types";
import posthog from "posthog-js";

interface FaqsListProps {
  category: Category;
  isOpen?: boolean;
}

export default function FaqsList({ category, isOpen = true }: FaqsListProps) {
  const [faqs, setFaqs] = useState<SanityFAQ[]>();
  const [openQuestion, setOpenQuestion] = useState<number>(-1);
  const [isLoading, setIsLoading] = useState(true);

  function handleOpenQuestion(index: number) {
    if (openQuestion === index) {
      setOpenQuestion(-1);
    } else {
      setOpenQuestion(index);
      if (faqs && faqs[index]) {
        posthog.capture("faq_question_opened", {
          question: faqs[index].question,
        });
      }
    }
  }

  useEffect(() => {
    if (!isOpen) {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setOpenQuestion(-1);
    }
  }, [isOpen]);

  useEffect(() => {
    async function getFaqs() {
      if (isOpen && !faqs) {
        try {
          setIsLoading(true);
          const faqsByCategory = await getFAQsByCategory(category);
          setFaqs(faqsByCategory);
          setIsLoading(false);
        } catch (error) {
          setFaqs([]);
          setIsLoading(false);
          console.error(error);
        }
      } else if (faqs) {
        setIsLoading(false);
      }
    }
    getFaqs();
  }, [category, isOpen, faqs]);

  if (isLoading && isOpen) {
    return null;
  }

  return (
    <ul className="flex flex-col lg:gap-5">
      {faqs && faqs.length > 0 ? (
        faqs.map((faq, index) => (
          <Question
            key={faq._id}
            index={index}
            question={faq.question}
            answer={faq.answer}
            isOpen={openQuestion === index}
            onQuestionOpen={handleOpenQuestion}
          />
        ))
      ) : (
        <p className="p-4 text-center text-gray-500">
          No FAQs available at the moment.
        </p>
      )}
    </ul>
  );
}
